module.exports = __webpack_public_path__ + "img/ts_2011.22738a1e.jpg";